import Gallery from './Gallery'
import Admin from './Admin'
import Error from './Error'

import { BrowserRouter as Router, Route } from 'react-router-dom'

function App() {
	return (
		<Router>
			<Route path='/yearbook/:bookName' component={Gallery} />
			<Route path='/admin' component={Admin} />
			<Route path='/' exact component={Error} />
		</Router>
	)
}

export default App
